import { ContactSupport } from "@p0security/frontend-core/react";
import { Button, Result } from "@p0security/ui";
import React, { useCallback } from "react";
import { FallbackProps } from "react-error-boundary";
import { useNavigate } from "react-router";

export const ErrorFallback: React.FC<FallbackProps> = ({
  resetErrorBoundary,
}) => {
  const navigate = useNavigate();

  const handleBackHome = useCallback(() => {
    resetErrorBoundary();
    navigate(`/`);
    window.location.reload();
  }, [navigate, resetErrorBoundary]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Result
        status="500"
        title="500"
        subTitle={
          <>
            Sorry, something went wrong. If the problem persists, please
            <ContactSupport subject={"Error Page - Issue Description"} />.
          </>
        }
        extra={
          <Button type="primary" onClick={handleBackHome}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};
